import styled from 'styled-components';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { half, quarter } from 'ui/theme/spacing';
import { Upload } from 'ui/icons';
import { LinkButton } from 'ui/linkButton';
import { useTranslation } from 'modules/domains/list';

import { LIST_IMPORT_URL } from '../../constants';
import { SecondaryActionsMenu } from './SecondaryActionsMenu';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${half};
`;

const UploadIcon = styled(Upload).attrs({ isColorInherited: true })`
  margin-right: ${quarter};
`;

export const PageActions = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <SecondaryActionsMenu />
      <LinkButton
        variant={BUTTON_VARIANTS.PRIMARY}
        size={BUTTON_SIZES.LARGE}
        to={LIST_IMPORT_URL}
        isAngular
      >
        <UploadIcon />
        {t('indexPage.pageActions.importList')}
      </LinkButton>
    </Wrapper>
  );
};
